import BannerXS from "/images/product/install-app-banner/banner-xs.webp?url";
import BannerM from "/images/product/install-app-banner/banner-m.webp?url";
import BannerML from "/images/product/install-app-banner/banner-ml.webp?url";
import BannerL from "/images/product/install-app-banner/banner-l.webp?url";
import BannerXL from "/images/product/install-app-banner/banner-xl.webp?url";

export const installAppBannerOptions = {
  appUrl: APP_INSTALL_URL,
  bgColor: "#FFE3F3",
  utmSource: "cosmetic.magnit.ru",
  images: {
    xs: BannerXS,
    m: BannerM,
    ml: BannerML,
    l: BannerL,
    xl: BannerXL,
  },
};
